import React, { Component } from 'react'
import { connect } from 'react-redux'
import Amount from '../Amount'
import Text from '../Text'
import Choose from '../Choose'
import CheckBox from '../CheckBox'
import css from './styles.scss'
import globalCss from '../../../../scss/global.scss'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { generateVariableKey } from '../../../utils'
import { updatedOptionsOrder, updatedMatchesOrder } from '../../../actions/actions'

export class Listing extends Component {
  constructor ({ list = [], schema }) {
    super()
    this.state = {
      items: list,
      report: false
    }
  }

  componentWillReceiveProps (nextProps) {
    const { list } = nextProps
    this.setState({
      items: list || []
    })
  }

  handleAddListing = () => {
    const { schema } = this.props
    const newItem = {}
    Object.keys(schema.fields).forEach(key => {
      newItem[key] = schema.fields[key].default
    })
    this.setState({
      items: [...this.state.items, newItem]
    }, () => this.save())
  }

  update = (key, val, idx) => {
    const muteableItems = [...this.state.items]
    muteableItems[idx][key] = val
    this.setState({
      items: muteableItems
    }, () => this.save())
  }

  removeListItem = idx => () => {
    const items = [...this.state.items]
    items.splice(idx, 1)
    this.setState({
      items
    }, () => this.save())
  }

  save = () => {
    const { save, dataKey, idx } = this.props
    const { items } = this.state
    save(dataKey, items, idx)
  }

  handleOnDragEnd = result => {
    try {
      const { destination: { index: newIdx }, source: { index: oldIdx }, draggableId } = result
      const { items } = this.state
      const updatedOption = items.filter(item => item.orderKey === draggableId)[0]
      if (updatedOption.hasOwnProperty('maxUses')) { // eslint-disable-line no-prototype-builtins
        this.props.dispatch(updatedMatchesOrder(newIdx, oldIdx, updatedOption))
      } else {
        this.props.dispatch(updatedOptionsOrder(newIdx, oldIdx, updatedOption))
      }
    } catch (error) {

    }
  }

  handleOnDragStart = () => {
    document.activeElement.blur()
  }

  render () {
    const { app: { primaryColor, isSafari }, report } = this.props
    const { schema } = this.props
    const { items } = this.state
    const { fields } = schema
    const listDisplay = items.map((item, i) => {
      const itemProps = Object.keys(schema.fields)
      item.orderKey = item.orderKey ? item.orderKey : generateVariableKey()
      const listContent = itemProps.map(key => {
        const localSchema = fields[key] || {}
        const comProps = {
          schema: localSchema,
          dataKey: key,
          save: this.update,
          idx: i,
          key,
          report,
          isSafari,
          isOption: true
        }
        let compContent = null
        switch (localSchema.type) {
          case 'number':
            compContent = (
              <Amount
                {...comProps}
                quantity={item[key]}
              />
            )
            break
          case 'text':
            compContent = (
              <Text
                {...comProps}
                string={item[key]}
              />
            )
            break
          case 'boolean':
            compContent = (
              <CheckBox
                {...comProps}
                checked={item[key]}
              />
            )
            break
          case 'select':
            compContent = (
              <Choose
                {...comProps}
                choice={item[key]}
              />
            )
            break
          case 'array': // Not allowed to have lists in lists
            compContent = null
            break
          default:
            compContent = null
            break
        }
        return (
          <div key={key}>
            {compContent}
          </div>
        )
      })
      return (

        <Draggable draggableId={item.orderKey} index={i} key={`${i}_chunk`}>
          {(provided, snapshot) => {
            return (
              <li
                key={i} className={`${css.li}`}
                {...provided.draggableProps}
                ref={provided.innerRef}
              >
                <span className={css.handle} {...provided.dragHandleProps}>
                  <div className={css.bars} />
                </span>
                <div className={css.del}>
                  <button
                    type='button'
                    className={css.delBtn}
                    onClick={this.removeListItem(i)}
                    style={{ color: primaryColor }}
                  >
              Delete This Option
                  </button>
                </div>
                {listContent}<br />

              </li>
            )
          }}
        </Draggable>
      )
    })
    return (
      <DragDropContext onDragEnd={this.handleOnDragEnd} onDragStart={this.handleOnDragStart}>
        <Droppable droppableId='options' type='OPTION'>
          {(provided, snapshot) => (
            <div
              className={css.Listing}
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              <h3 className={css.h3}>
                <span className={css.schemas}>
                  {schema.templates.join(', ')}
                </span>
                {schema.label}
              </h3>
              <div className={css.list}>
                <ul>
                  {listDisplay}
                </ul>
                <div className={css.new}>
                  <button
                    className={css.add}
                    onClick={this.handleAddListing}
                    type='button' style={{ backgroundColor: primaryColor }}
                  >
                    <i className={globalCss.iconPlus} />
                  </button>
                </div>
              </div>
            </div>
          )}
        </Droppable>
      </DragDropContext>
    )
  }
}
const mapStateToProps = state => {
  const { app } = state
  return {
    app
  }
}

export default connect(mapStateToProps)(Listing)



// WEBPACK FOOTER //
// /app/js/components/EditorGUI/Listing/index.js